'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FormattedFaxNumber = _react2['default'].createClass({
    displayName: 'FormattedFaxNumber',


    propTypes: {
        faxNumber: _react2['default'].PropTypes.string.isRequired
    },

    componentWillMount: function componentWillMount() {
        var formattedFaxNumber = hellofaxJS.formatInternationalFaxNumber(this.props.faxNumber);
        this.setState({ formattedFaxNumber: formattedFaxNumber });
    },

    render: function render() {
        return _jsx('span', {
            className: 'fax-number'
        }, void 0, this.state.formattedFaxNumber);
    }

});
module.exports = FormattedFaxNumber;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/formatted-fax-number.jsx
 ** module id = 807
 ** module chunks = 0
 **/